export default class CartInterector {

  constructor(service) {
    this.service = service
  }

  getData() {
    return this.service.getData();
  }
}